import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateBaptism$ } from "../schemas/schemas_0";
export class CreateBaptismCommand extends command(_ep0, _mw0, "CreateBaptism", CreateBaptism$) {
}
